import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Wrapper = styled.div`
  box-sizing: border-box;

  padding: 146px 0;
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, #0a1321 0%, #0f231f 100%);

  @media (max-width: 1480px) {
    padding: 146px 16px;
  }
`;

export const Container = styled.div`
  max-width: 1440px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 90px;

  @media ${media.mobile} {
    gap: 34px;
  }
`;

export const Header = styled.div`
  position: relative;
  font-family: 'Aggro', sans-serif;
  font-size: 42px;
  letter-spacing: -0.02em;

  @media ${media.mobile} {
    font-size: 24px;
  }
`;

export const Title = styled.div`
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  white-space: nowrap;

  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;

  text-shadow:
    -2px -2px 0 #000000,
    2px -2px 0 #000000,
    -2px 2px 0 #000000,
    2px 2px 0 #000000,
    0 -2px 0 #000000,
    0 2px 0 #000000,
    -2px 0 0 #000000,
    2px 0 0 #000000;

  .highlight {
    color: #07d993;
  }

  @media ${media.mobile} {
    bottom: 30px;
  }
`;

export const CenterImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media ${media.mobile} {
    width: 155px;
    height: auto;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
`;

export const ContentTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;

  @media ${media.mobile} {
    gap: 20px;
  }
`;
